// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rrEpAq4z_i6vPLhbpPvN {\n\tmax-width: 850px;\n}\n", "",{"version":3,"sources":["webpack://./client/src/screens/management/general/GeneralSettings.module.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;AACjB","sourcesContent":[".details {\n\tmax-width: 850px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"details": "rrEpAq4z_i6vPLhbpPvN"
};
export default ___CSS_LOADER_EXPORT___;
